import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import BoltIcon from '@mui/icons-material/Bolt';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import { colors } from '@styles/colors';

/**
 * Botón circular de acción en tablas (mismo criterio visual que Miembros → citas médicas).
 * @param {string} icono - Clave: 'edit' | 'localHospital' | 'familyRestroom' | 'bolt' | 'delete' | 'save'
 * @param {string} tooltipText - title y aria-label
 * @param {function} onClick
 * @param {boolean} [disabled=false]
 * @param {string} [colorActivo=colors.accent] - Color de fondo cuando está habilitado
 */
const ICONOS = {
  edit: EditIcon,
  localHospital: LocalHospitalIcon,
  familyRestroom: FamilyRestroomIcon,
  bolt: BoltIcon,
  delete: DeleteIcon,
  save: SaveIcon,
};

function BotonIconoTabla({
  icono,
  tooltipText,
  onClick,
  disabled = false,
  colorActivo = colors.accent,
}) {
  const Icon = ICONOS[icono];
  if (!Icon) {
    console.warn(`BotonIconoTabla: icono "${icono}" no reconocido. Use: ${Object.keys(ICONOS).join(', ')}`);
    return null;
  }

  return (
    <button
      type="button"
      title={tooltipText}
      aria-label={tooltipText}
      onClick={onClick}
      disabled={disabled}
      style={{
        width: '4.2vh',
        height: '4.2vh',
        borderRadius: '50%',
        border: 'none',
        backgroundColor: disabled ? colors.gray400 : colorActivo,
        color: colors.white,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: disabled ? 'not-allowed' : 'pointer',
        padding: 0,
      }}
    >
      <Icon style={{ fontSize: '2.4vh' }} />
    </button>
  );
}

export default BotonIconoTabla;
